import { useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { ConversationContainer } from '@/features/messaging';
import { ImageLightbox } from '@/components/molecules/image-lightbox';

export default function OrderConversationPage() {
  const { id: orderId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Lightbox state
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState<string>('');

  const handleBack = () => {
    navigate(-1);
  };

  const handleImageClick = useCallback((imageUrl: string) => {
    setLightboxImage(imageUrl);
    setLightboxOpen(true);
  }, []);

  if (!orderId) {
    return null;
  }

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] md:h-[calc(100vh-5rem)]">
      {/* Header */}
      <div className="flex items-center gap-3 p-4 border-b bg-background">
        <Button variant="ghost" size="icon" onClick={handleBack}>
          <ArrowLeft className="size-5" />
        </Button>
        <div>
          <h1 className="text-lg font-semibold">
            {t('messaging.title', 'Messages')}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t('messaging.orderConversation', { orderId }).replace('{{orderId}}', orderId)}
          </p>
        </div>
      </div>

      {/* Conversation */}
      <div className="flex-1 overflow-hidden">
        <ConversationContainer orderId={orderId} onImageClick={handleImageClick} />
      </div>

      {/* Image Lightbox */}
      <ImageLightbox
        images={lightboxImage ? [lightboxImage] : []}
        selectedIndex={0}
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onChangeIndex={() => {}}
      />
    </div>
  );
}
